import PageHead from "@/components/header/PageHead";
import SubPoolOffBoarding from '@/components/subpool/offboarding/SubPoolOffBoarding';
import { getPrefix } from "@/utils/common";
export default {
  name: "SubPoolOffboardingPage",
  components: {
    PageHead,
    SubPoolOffBoarding
  },
  data() {
    return {
      nodeId: '',
      poolAddress: ''
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.poolAddress = this.$route.params.poolAddress;
      this.nodeId = getPrefix() + this.$route.params.provider;
    }
  },
  computed: {
    docsUrlPrefix() {
      return `https://docs.stfil.io/${this.$i18n.locale === "zh" ? 'v/cn/' : ''}`;
    }
  }
};